// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Uuid = require("uuid");
var Decco = require("decco/src/Decco.bs.js");
var $$String = require("rescript/lib/js/string.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Webapi__Dom__HtmlElement = require("rescript-webapi/src/Webapi/Dom/Webapi__Dom__HtmlElement.bs.js");

var t_encode = Decco.stringToJson;

var t_decode = Decco.stringFromJson;

function make(param) {
  return Uuid.v1();
}

function stringify(id) {
  return id;
}

var cmp = $$String.compare;

var ContentScriptFailureId = {
  t_encode: t_encode,
  t_decode: t_decode,
  make: make,
  stringify: stringify,
  cmp: cmp
};

function t_encode$1(v) {
  if (v.TAG === /* ContentScriptFailure */0) {
    return [
            "ContentScriptFailure",
            Decco.stringToJson(v._0)
          ];
  } else {
    return [
            "ErrorMessage",
            Decco.stringToJson(v._0)
          ];
  }
}

function t_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ContentScriptFailure" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ContentScriptFailure */0,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "ErrorMessage" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* ErrorMessage */1,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$1(responseError) {
  if (responseError.TAG === /* ContentScriptFailure */0) {
    return "ContentScriptFailure(failureId=" + (responseError._0 + ")");
  } else {
    return "ErrorMessage(" + (responseError._0 + ")");
  }
}

var ContentScriptResponseError = {
  t_encode: t_encode$1,
  t_decode: t_decode$1,
  stringify: stringify$1
};

function nthChild_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "NthChild" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.intFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* NthChild */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "OnlyChild" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* OnlyChild */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function nthChild_encode(v) {
  if (v) {
    return [
            "NthChild",
            Decco.intToJson(v._0)
          ];
  } else {
    return ["OnlyChild"];
  }
}

function node_encode(v) {
  return Js_dict.fromArray([
              [
                "tag",
                Decco.stringToJson(v.tag)
              ],
              [
                "nthChild",
                nthChild_encode(v.nthChild)
              ]
            ]);
}

function node_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var tag = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "tag"), null));
  if (tag.TAG === /* Ok */0) {
    var nthChild = nthChild_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "nthChild"), null));
    if (nthChild.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                tag: tag._0,
                nthChild: nthChild._0
              }
            };
    }
    var e = nthChild._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".nthChild" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = tag._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".tag" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function nodesFromHtmlElement(htmlElement) {
  var walkUp = function (htmlElement) {
    var tag = htmlElement.tagName.toLowerCase();
    var parentHtmlElement = Belt_Option.flatMap(Caml_option.nullable_to_opt(htmlElement.parentElement), Webapi__Dom__HtmlElement.ofElement);
    if (parentHtmlElement === undefined) {
      return [{
                tag: tag,
                nthChild: /* OnlyChild */0
              }];
    }
    var parentHtmlElement$1 = Caml_option.valFromOption(parentHtmlElement);
    var siblingHtmlElemnts = Belt_Array.keepMap(Array.prototype.slice.call(parentHtmlElement$1.childNodes), Webapi__Dom__HtmlElement.ofNode);
    var index = siblingHtmlElemnts.findIndex(function (sibHtmlElement) {
          return sibHtmlElement === htmlElement;
        });
    var nthChild = index !== 0 || siblingHtmlElemnts.length !== 1 ? /* NthChild */({
          _0: index + 1 | 0
        }) : /* OnlyChild */0;
    return Belt_Array.concat(walkUp(parentHtmlElement$1), [{
                  tag: tag,
                  nthChild: nthChild
                }]);
  };
  return walkUp(htmlElement);
}

function asXPathExpr(nodes) {
  var separator = "/";
  return separator + Belt_Array.map(nodes, (function (param) {
                  var nthChild = param.nthChild;
                  var tag = param.tag;
                  if (nthChild) {
                    return "" + tag + "[" + nthChild._0 + "]";
                  } else {
                    return tag;
                  }
                })).join(separator);
}

var Path = {
  node_encode: node_encode,
  node_decode: node_decode,
  nthChild_encode: nthChild_encode,
  nthChild_decode: nthChild_decode,
  nodesFromHtmlElement: nodesFromHtmlElement,
  asXPathExpr: asXPathExpr
};

function t_encode$2(v) {
  return [
          "Path",
          Decco.arrayToJson(node_encode, v._0)
        ];
}

function t_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Path") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.arrayFromJson(node_decode, Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* Path */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function stringify$2(elementRef) {
  return "Path(" + (asXPathExpr(elementRef._0) + ")");
}

var ElementRef = {
  Path: Path,
  t_encode: t_encode$2,
  t_decode: t_decode$2,
  stringify: stringify$2
};

exports.ContentScriptFailureId = ContentScriptFailureId;
exports.ContentScriptResponseError = ContentScriptResponseError;
exports.ElementRef = ElementRef;
/* uuid Not a pure module */
